const LIST = '/sales/dailyreport/list'
const EXPORT = '/sales/dailyreport/export'
const INFO_ONE_CAJA = '/sales/dailyreport/onedailycash/'
const CREATE = '/sales/dailyreport/create'
const DATA_BEFORE = '/sales/dailyreport/before'
const CONFIRM_CAJA = '/sales/dailyreport/confirm'
const UPDATE_CAJA = '/sales/dailyreport/updatecash'
const ADD_GASTO = '/sales/dailyreport/addgasto'
const PRINT = '/sales/dailyreport/print'
const PRINT_GASTOS = '/sales/dailyreport/printgastos'

export const salesCajaEndpoints = {
  LIST,
  EXPORT,
  INFO_ONE_CAJA,
  CREATE,
  DATA_BEFORE,
  CONFIRM_CAJA,
  UPDATE_CAJA,
  ADD_GASTO,
  PRINT,
  PRINT_GASTOS,
}
